import { useCallback, useEffect, useState } from "react";
import { PLATFORM_CONFIG } from "../../../network/config/ApiConfig";
import { getShopStores } from "../../../network/service/ShopService";

const KEY = "shopStoreId";

function remembered() {
  try {
    return Number(localStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
}

/**
 * The store whose listings and prices the shop shows: the one picked last,
 * else REACT_APP_SHOP_STORE_ID, else the first active store.
 */
export function useShopStore() {
  const [storeId, setStoreId] = useState(remembered() ?? PLATFORM_CONFIG.SHOP_STORE_ID);
  const [stores, setStores] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    getShopStores()
      .then((page) => {
        if (!alive) return;
        setStores(page.items);
        setStoreId((current) =>
          current && page.items.some((s) => s.id === current) ? current : page.items[0]?.id ?? null,
        );
      })
      .catch((e) => alive && setError(e));
    return () => {
      alive = false;
    };
  }, []);

  const choose = useCallback((id) => {
    setStoreId(id);
    try {
      localStorage.setItem(KEY, String(id));
    } catch {
      // Private mode: the choice lasts for this visit only.
    }
  }, []);

  return { storeId, stores, choose, error };
}
